import type { CorrectedRow } from './ScoreCorrectionPanel'
import { PencilLine } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { userDisplayName } from '~/helpers/users/display-name'
import { formatScore } from '../score-format'

type Props = {
  row: CorrectedRow
  /** L'admin seul corrige (#161) ; les autres voient le score et la mention « corrigé ». */
  onCorrect?: () => void
}

/** Le score d'une ligne de statistiques, sa mention « corrigé » et, pour l'admin, l'action de correction. */
function ScoreCell({ row, onCorrect }: Props) {
  const { t } = useTranslation()
  const name = userDisplayName({ firstName: row.userFirstName, lastName: row.userLastName, email: row.userEmail })

  return (
    <span className="inline-flex items-center gap-1.5">
      {formatScore(row.scoreRaw, row.scoreMax) ?? '-'}
      {row.correctedScore != null && <span className="text-xs text-muted-foreground">{t('scoreCorrection.corrected')}</span>}
      {onCorrect && (
        <Button type="button" variant="ghost" size="icon" className="size-7" onClick={onCorrect} aria-label={t('scoreCorrection.open', { name })} title={t('scoreCorrection.open', { name })}>
          <PencilLine className="size-4" />
        </Button>
      )}
    </span>
  )
}

export default ScoreCell
